export default __webpack_public_path__ + "static/media/sender.79b41e26.png";